import { Popup } from 'react-leaflet';

class ExtendedPopup extends Popup {
    componentDidMount() {
        super.componentDidMount();
        if (this.leafletElement){
            this.leafletElement.options.offset = [220, 130];
            this.leafletElement.options.closeOnClick = false;
            this.leafletElement.options.closeButton = false;
            this.leafletElement.options.autoPanPaddingBottomRight = [0, 200];
            this.leafletElement.update();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        if (this.leafletElement){
            this.leafletElement.options.offset = [220, 130];
            this.leafletElement.options.closeOnClick = false;
            this.leafletElement.options.closeButton = false;
            this.leafletElement.options.autoPanPaddingBottomRight = [0, 200];
            this.leafletElement.update();
        }
    }
}

export default ExtendedPopup;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PopupContainer/components/ExtendedPopup/index.js